import { useNavigate } from 'react-router-dom';
import { Title, useCanAccess, useGetIdentity, useStore } from 'react-admin';
import { Box, Button, Stack, Tab, Tabs } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { CardBoard } from './CardBoard';
import { CardDateList } from './CardDateList';

type JobsTab = 'mine' | 'all';

/** /cards list page: date list for everyone; superusers also get the status board below. */
export const CardJobs = () => {
    const navigate = useNavigate();
    const { identity } = useGetIdentity();
    const isAdmin = Boolean((identity as { administrator?: boolean } | undefined)?.administrator);
    // Persisted so the dialog routes (/cards/create, /cards/:id/show) that render
    // their own CardJobs behind the modal keep the tab the user was on.
    const [tab, setTab] = useStore<JobsTab>('cards.jobsTab', 'mine');

    const { canAccess: canCreate } = useCanAccess({
        resource: 'cards',
        action: 'create',
    });

    return (
        <Box sx={{ py: 3, px: { xs: 2, sm: 3 } }}>
            <Title title="Jobs" />

            <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                sx={{ mb: 2, gap: 2 }}
            >
                {canCreate && (
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={() => navigate('/cards/create', { replace: true })}
                    >
                        New Job
                    </Button>
                )}
            </Stack>

            {isAdmin ? (
                <>
                    <Tabs value={tab} onChange={(_, value: JobsTab) => setTab(value)} sx={{ mb: 2 }}>
                        <Tab value="mine" label="Mine" />
                        <Tab value="all" label="Global" />
                    </Tabs>
                    {tab === 'mine' ? (
                        <CardDateList assignedToMe />
                    ) : (
                        <CardBoard hideCreate />
                    )}
                </>
            ) : (
                <CardDateList assignedToMe />
            )}
        </Box>
    );
};

CardJobs.displayName = 'CardJobs';
